// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase'
const firebaseConfig = {
    apiKey: "AIzaSyCqPWCK6SJMzliRZkZS131YmAx-8jHuvnQ",
    authDomain: "gech-660b1.firebaseapp.com",
    projectId: "gech-660b1",
    storageBucket: "gech-660b1.appspot.com",
    messagingSenderId: "220303458643",
    appId: "1:220303458643:web:03fd4251292ed98c48a1a6",
    measurementId: "G-ZMMNXWJ0V5"
  };
 const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
export { db, auth };

